import React from 'react';

const ConditionalDiv = ({ children, className = '', style = {}, ...props }) => {
  // Convert children to array and filter out null, undefined, false, and empty strings
  const childArray = React.Children.toArray(children);
  
  // Check if there are any valid children
  const hasValidChildren = childArray.some(child => {
    // Handle null, undefined, false, true
    if (child === null || child === undefined || typeof child === 'boolean') {
      return false;
    }
    
    // Handle empty strings
    if (typeof child === 'string' && child.trim() === '') {
      return false;
    }
    
    // Handle React elements (components, JSX)
    if (React.isValidElement(child)) {
      return true;
    }
    
    // Handle arrays (nested children)
    if (Array.isArray(child)) {
      return child.length > 0;
    }
    
    // Any other truthy value
    return Boolean(child);
  });
  
  // If no valid children, return null (don't render anything)
  if (!hasValidChildren) {
    return null;
  }
  
  // Render the div with all children
  return (
    <div className={className} style={style} {...props}>
      {children}
    </div>
  );
};

export default ConditionalDiv;